import { useParams } from "react-router-dom";
import Page404 from "../../../pages/auth/Page404";
import useAppSelector from "../../../hooks/useAppSelector";
import {
  loadLicenceProfileAsync,
  selectLicenceProfileResponse,
} from "../../../redux/slices/licenceProfile";
import useAppDispatch from "../../../hooks/useAppDispatch";
import Loading from "../../../leap-components/Loading";
import { useState } from "react";
import {
  GetLicenceProfileNotReadyComponent,
  IsLicenceProfileReady,
} from "../../../leap-components/LicenceProfile/LicenceProfileResponseComponentFactory";
import { ILicenceProfile } from "../../../api/ILicenceProfile";
import Page500 from "../../../pages/auth/Page500";
import {
  loadFullLicenceDetailsAsync,
  selectLicence,
} from "../../../redux/slices/licence";
import HistoricLicence from "./HistoricLicence";
import ApplicationLicence from "./ApplicationAuhtorisation";
import {
  loadLicensingActionOptionsAsync,
  selectLicensingActionOptions,
} from "../../../redux/slices/licensingActionOptions";
import {
  loadSubmissionOptionsAsync,
  selectSubmissionOptions,
} from "../../../redux/slices/submissionOptions";
import {
  loadChangeRequestsOptionsAsync,
  selectChangeRequestsOptions,
} from "../../../redux/slices/changeRequestOptions";
import licenceTransfersOptions, {
  loadLicenceTransfersOptionsAsync,
  selectLicenceTransfersOptions,
} from "../../../redux/slices/licenceTransfersOptions";
import { LicenceTypes } from "../../../api/LicenceDetails";
import useDetectScreenBreakpoints from "../../../hooks/useDetectScreenBreakpoints";
import { batch } from "react-redux";

const Licence = () => {
  const screenBreakpoints = useDetectScreenBreakpoints();

  const [loading, setLoading] = useState(false);
  const [loadingLicenceId, setLoadingLicenceId] = useState("");
  const licenceProfileSelector = useAppSelector(selectLicenceProfileResponse);
  const licenceSelector = useAppSelector(selectLicence);

  const [isLoadingLicensingOptions, setLoadingLicensingOptions] =
    useState(false);
  const licensingOptionsSelector = useAppSelector(selectLicensingActionOptions);

  const [isLoadingSubmissionOptions, setLoadingSubmissionOptions] =
    useState(false);
  const submissionsOptionsSelector = useAppSelector(selectSubmissionOptions);

  const [isLoadingChangeRequestsOptions, setLoadingChangeRequestsOptions] =
    useState(false);
  const changeRequestsOptionsSelector = useAppSelector(
    selectChangeRequestsOptions
  );

  const [isLoadingTransfersOptions, setLoadingTransfersOptions] =
    useState(false);
  const licenceTransfersOptionsSelector = useAppSelector(
    selectLicenceTransfersOptions
  );
  const dispatch = useAppDispatch();

  let { profileNo, licenceId } = useParams();
  if (!profileNo || !licenceId) {
    return <Page404 />;
  }

  if (!loading) {
    setLoading(true);
    setLoadingLicenceId(licenceId);
    batch(() => {
      dispatch(loadLicenceProfileAsync(profileNo ? profileNo : ""));
      dispatch(loadFullLicenceDetailsAsync(licenceId ? licenceId : ""));
      dispatch(loadLicensingActionOptionsAsync());
      dispatch(loadSubmissionOptionsAsync());
      dispatch(loadChangeRequestsOptionsAsync());
      dispatch(loadLicenceTransfersOptionsAsync());
    });

    return <Loading />;
  }

  if (!IsLicenceProfileReady(licenceProfileSelector.licenceProfileResponse)) {
    return GetLicenceProfileNotReadyComponent(
      licenceProfileSelector.licenceProfileResponse
    );
  }

  const licenceProfile = licenceProfileSelector.licenceProfileResponse
    ?.licenceProfile as ILicenceProfile;

  /*
  if (!isLoadingLicensingOptions) {
    setLoadingLicensingOptions(true);
    return <Loading />;
  }

  if (!isLoadingSubmissionOptions) {
    setLoadingSubmissionOptions(true);
    
    return <Loading />;
  }

  if (!isLoadingChangeRequestsOptions) {
    setLoadingChangeRequestsOptions(true);
    return <Loading />;
  }

  if (!isLoadingTransfersOptions) {
    setLoadingTransfersOptions(true);
    return <Loading />;
  }

  
  if (loadingLicenceId !== licenceId) {
    
    return <Loading />;
  }*/

  if (
    !licensingOptionsSelector.licensingActionTypes ||
    !licensingOptionsSelector.licensingActionStatuses
  ) {
    return <Loading />;
  }

  if (
    !submissionsOptionsSelector.submissionTypes ||
    !submissionsOptionsSelector.submissionObjectorTypes
  ) {
    return <Loading />;
  }

  if (!changeRequestsOptionsSelector.changeRequestStatuses) {
    return <Loading />;
  }

  if (!licenceTransfersOptionsSelector.licenceTransferStatuses) {
    return <Loading />;
  }

  const licence = licenceSelector.licence;

  if (!licence) {
    return <Loading />;
  }

  if (!licence.response.ok) {
    if (licence.response.status === 404) {
      return <Page404 />;
    } else {
      return <Page500 />;
    }
  }

  if (
    !licence.documentCreatedByFilterValues ||
    !licence.documentClassificationFilterValues ||
    !licence.documentSubclassificationFilterValues
  ) {
    return <Loading />;
  }

  if (
    licence.licencetype === LicenceTypes.VOC ||
    licence.licencetype === LicenceTypes.HL ||
    licence.pregolive
  ) {
    return (
      <HistoricLicence
        licenceProfile={licenceProfile}
        licence={licence}
        profileNo={profileNo}
        screenBreakpoints={screenBreakpoints}
      />
    );
  } else {
    return (
      <ApplicationLicence
        licenceProfile={licenceProfile}
        licence={licence}
        profileNo={profileNo}
        licensingActionStatuses={
          licensingOptionsSelector.licensingActionStatuses
        }
        licensingActionTypes={licensingOptionsSelector.licensingActionTypes}
        submissionTypes={submissionsOptionsSelector.submissionTypes}
        submissionObjectorTypes={
          submissionsOptionsSelector.submissionObjectorTypes
        }
        changeRequestsStatuses={
          changeRequestsOptionsSelector.changeRequestStatuses
        }
        licenceTransfersStatuses={
          licenceTransfersOptionsSelector.licenceTransferStatuses
        }
        screenBreakpoints={screenBreakpoints}
      />
    );
  }
};

export default Licence;
